<app-form-input
[parentForm]="parentForm"
[value]="organisme.nomOfficiel"

[label]="step2.getnomofficiel"
[type]="'text'"
[disabled]="disabled"
     [rule]="'minSize_1|maxSize_400|required'"
[name]="getUid()+'_SepAtt_nomOfficiel'">
</app-form-input>

<app-type-num-identification-national  [uid]="getUid()" [parentForm]="parentForm" [typeIdentificationNational]="organisme.typeIdentificationNational" [disabled]="disabled"></app-type-num-identification-national>

<app-form-input
[parentForm]="parentForm"
[value]="organisme.codeIdentificationNational"

[label]="step2.getcodeidentificationnational"
[type]="'number'"
[disabled]="disabled"
[rule]="'minSize_1|maxSize_50|required'"
[name]="getUid()+'_SepAtt_codeIdentificationNational'">
</app-form-input>

<app-form-input
[parentForm]="parentForm"
[value]="organisme.ville"

[label]="step2.getville"
[type]="'text'"
[disabled]="disabled"
[rule]="'pattern_21|maxSize_100'"
[errorMessage]="{'pattern' : 'ctr_40_HorsDef', 'maxLength' : 'ctr_40_HorsDef'}"
[name]="getUid()+'_SepAtt_ville'">
</app-form-input>

<app-form-input
[parentForm]="parentForm"
[value]="organisme.cp"

[label]="step2.getcp"
[type]="'text'"
[disabled]="disabled"
[rule]="'pattern_3'"
[errorMessage]="{'pattern' : 'ctr_118'}"
[name]="getUid()+'_SepAtt_cp'">
</app-form-input>
<app-form-input-error [activeForm]="parentForm" [name]="getStepId() + rg1" [id]="getStepId() + rg1"></app-form-input-error>

<app-type-oui-non-grp-acheteur [uid]="getUid()" [parentForm]="parentForm" [disabled]="disabled"
[grpCommandes]="organisme.grpCommandes"></app-type-oui-non-grp-acheteur>








